const prefix = '/therapists';
const bookingsPrefix = '/bookings';
const publicBookingsPrefix = '/public/bookings';

const ApiRoutes = {
  BestByZip: prefix + '/best-by-zip/{zip}',
  FindById: prefix + '/by-id/{id}',
  BulkSearchByZip: prefix + '/bulk-search-by-zip',
  Book: prefix + '/book',
  CancelBooking: bookingsPrefix + '/{id}/cancel',
  NoshowBooking: bookingsPrefix + '/{id}/noshow',
  RestoreBooking: bookingsPrefix + '/{id}/restore',
  RescheduleBooking: bookingsPrefix + '/{id}/reschedule',
  PublicBookingShow: publicBookingsPrefix + '/{token}',
  PublicBookingPrepare: publicBookingsPrefix + '/by-id/{id}/prepare',
  PublicBookingCancel: publicBookingsPrefix + '/{token}/cancel',
  PublicBookingReschedule: publicBookingsPrefix + '/{token}/reschedule',
};

export default ApiRoutes;
